import validate from "/usr/src/app/content/n3-promos-ec907406-be02-485f-97b9-88a33d19af50/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-ec907406-be02-485f-97b9-88a33d19af50/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}